import { Box, ChipGroup, Flex, Text } from '@shared/components';

import { UserTypeAvatar } from '../../../containers/user-type-avatar';

interface UserCardProps {
  roles: string[];
  firstName: string;
  lastName: string;
  email: string;
  profilePic: string;
}

export function UserCard(props: Readonly<UserCardProps>) {
  const { firstName, lastName, email, profilePic, roles, ...restProps } = props;
  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: theme.shape.rounded(2),
        p: theme.spacing(3, 4),
        maxWidth: 264,
        width: '100%',
      })}
      {...restProps}
    >
      <Flex sx={{ gap: (theme) => theme.spacing(3), alignItems: 'center' }}>
        <UserTypeAvatar fullName={`${firstName} ${lastName}`} src={profilePic} email={email} />
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <Box>
            <Text variant='body1Semibold'>
              {firstName} {lastName}
            </Text>
            <Text variant='body2' color='text.secondary'>
              {email}
            </Text>
          </Box>
          <ChipGroup labels={roles} limit={2} />
        </Flex>
      </Flex>
    </Box>
  );
}
